import { Reducer } from 'redux';
import { SynopticState, SynopticTypes } from './types';

const INITIAL_STATE: SynopticState = {
  monitoringList: null,
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<SynopticState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES MONITORING LIST
    case SynopticTypes.LIST_SYNOPTIC_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        monitoringList: INITIAL_STATE.monitoringList,
      };
    case SynopticTypes.LIST_SYNOPTIC_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        monitoringList: action.payload.monitoringList,
        totalCount: action.payload.totalCount,
      };
    case SynopticTypes.LIST_SYNOPTIC_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        monitoringList: INITIAL_STATE.monitoringList,
      };

    default:
      return state;
  }
};

export default reducer;
